<template>
  <el-dialog
    :title="getTitle"
    :visible.sync="dialogVisible"
    width="85%"
    center
    :before-close="closeDialog"
    class="add-contragent-to-user-modal"
    @close="closeDialog"
    @open="handleOpenDialog"
  >
    <div class="head-section">
      <search-input
        placeholder="Поиск по Названию организации (ИП), ИНН"
        :debounce="3000"
        :value="search"
        @clear="clearFilter"
        @search="filteredList"
        @input="onInput"
      />
    </div>

    <el-row
      v-if="getContragents.length && !loading"
      type="flex"
      :gutter="24"
      style="text-align: center"
      class="add-contragent-to-user-modal__head"
    >
      <el-col :span="2">Дата</el-col>
      <el-col :span="2" />
      <el-col :span="10">Название</el-col>
      <el-col :span="3">ИНН и телефон</el-col>
      <el-col :span="3">Договор ПТ</el-col>
      <el-col :span="3">Договор ПТЭ</el-col>
      <el-col :span="1" />
    </el-row>

    <div
      v-for="contragent in getContragents"
      :key="contragent.id"
      class="check-list"
      style="cursor: default"
    >
      <el-row :gutter="24" type="flex" align="middle">
        <el-col class="auto-list_col" :span="2">
          <div class="check-list-person auto-list_col_centered">
            <div>
              <p class="date">
                {{ dateToFormat(contragent.created_at) | wordDate }}
              </p>
              <p class="date">
                {{ dateToFormat(contragent.created_at) | sliceDate }}
              </p>
            </div>
          </div>
        </el-col>
        <el-col v-if="!isMobile" class="auto-list_col" :span="2">
          <div class="check-list-person auto-list_col_centered">
            <p>
              <accreditation-lists-icon :approve-data="contragent" />
            </p>
          </div>
        </el-col>
        <el-col class="auto-list_col" :span="10">
          <div class="check-list-person auto-list_col_centered">
            <div>
              <p>{{ contragent.org_name }}</p>
              <el-rate v-model="rate_user" disabled :colors="rate_color" />
            </div>
          </div>
        </el-col>
        <el-col class="auto-list_col" :span="3">
          <div class="check-list-phone grey auto-list_col_centered">
            <div class="check-list-autos">
              <p>ИНН {{ contragent.inn }}</p>
              <p>{{ contragent.phone }}</p>
            </div>
          </div>
        </el-col>
        <el-col class="auto-list_col" :span="3">
          <div class="check-list-autos auto-list_col_centered">
            <p>{{ contractNum(contragent.contract) }}</p>
          </div>
        </el-col>
        <el-col class="auto-list_col" :span="3">
          <div class="check-list-autos auto-list_col_centered">
            <p>{{ contractNum(contragent.contract_pte) }}</p>
          </div>
        </el-col>
        <el-col class="auto-list_col" :span="1">
          <div class="check-list-autos auto-list_col_centered">
            <el-button
              type="primary"
              icon="el-icon-circle-plus"
              circle
              @click="handleAddContragentToUser(contragent.id)"
            />
          </div>
        </el-col>
      </el-row>
    </div>
    <section class="bottom-section">
      <div class="pagination">
        <pagination-custom :data="getMeta" @changed="changePage" />
      </div>
    </section>
  </el-dialog>
</template>

<script>
import { debounce } from '@/helpers/functions'
import { mapGetters } from 'vuex'
import AccreditationListsIcon from '@/components/Accreditation/AccreditationListsIcon'
import PaginationCustom from '@/components/Tables/PaginationCustom'
import SearchInput from '@/components/Shared/SearchInput'

export default {
  name: 'AddContragent',
  components: { AccreditationListsIcon, PaginationCustom, SearchInput },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    currentUser: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    curPage: 1,
    search: '',
    rate_color: ['#3498DB', '#3498DB', '#3498DB'],
    rate_user: 3,
  }),
  computed: {
    ...mapGetters({
      getContragents: 'getContragents',
      // getTotalCount: 'getTotalCount',
      getMeta: 'getMeta',
      loading: 'getContragentLoading',
    }),
    getTitle() {
      return `Добавить контрагента для пользователя - ${
        this.currentUser?.fio || this.currentUser?.login
      }`
    },
  },
  methods: {
    filteredList() {
      const filterValue = `${String(this.search).trim()}&page=${this.curPage}`

      if (filterValue.length > 2) {
        this.$store.dispatch('fetchContragentsFilter', filterValue)
      }
      if (!filterValue) {
        this.listContr()
      }
    },
    clearFilter() {
      this.search = ''
      this.changePage()
    },
    onInput(cur) {
      debounce(() => {
        this.search = cur
        this.filteredList()
      }, 500)
    },
    listContr() {
      this.$store.dispatch('fetchContragents', { page: this.curPage })
    },
    changePage(page = 1) {
      this.curPage = page
      this.filteredList()
    },
    handleAddContragentToUser(contragentId) {
      this.$emit('addContragentToUser', {
        user_id: this.currentUser.id,
        contragent_id: contragentId,
      })
    },
    closeDialog() {
      this.$emit('close')
      this.clearForm()
    },
    clearForm() {
      this.search = ''
    },
    contractNum(contract) {
      let num = 'Нет данных'

      if (contract && contract.document && contract.document.number) {
        num = '№ ' + contract.document.number
      }

      return num
    },
    handleOpenDialog() {
      this.listContr()
    },
  },
}
</script>

<style lang="sass">
.add-contragent-to-user-modal
  .head-section
    margin-bottom: 32px

  &__head
    margin-bottom: 16px

  .auto-list_col
    > *
      text-align: center

  .check-list
    border-top: 1px solid #ebeef5
    &:last-of-type
      border-bottom: 1px solid #ebeef5
</style>
